import { TuneCoreExportSuccessDialog } from '../TuneCoreExportSuccessDialog';
import { TuneCoreExportFailureDialog } from '../TuneCoreExportFailureDialog';

export const GlobalDialogs = () => {
  return (
    <>
      <TuneCoreExportSuccessDialog />
      <TuneCoreExportFailureDialog />
    </>
  );
};
